import trackEvent from './trackEvent'

const newsletterSubscriptionRequestEvent = (): void => {
  trackEvent({
    event: 'newsletterSubscriptionRequest',
    moduleContext: 'footer',
  })
}

export default newsletterSubscriptionRequestEvent
